import styled from 'styled-components';
import { Z_INDEXES } from '../../util/vars';
import { DEFAULT_TRANSITION_FUNC } from '../../util/styled';
import { SWISHPANEL_CONTENT } from '../../util/data-id';

const TIMES: Record<'false' | 'true', number> = {
  false: 350,
  true: 350,
};

export const SwishPanelMaskStyled = styled('div')<{
  $alwaysOnTop: boolean
}>`
  display: flex;
  position: fixed;
  z-index: ${(props) => Z_INDEXES.max  + (props.$alwaysOnTop ? 1 : 0)};
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  overflow: auto;  
  transition: all ${TIMES.false}ms ${DEFAULT_TRANSITION_FUNC};
  transition-delay: ${TIMES.false}ms;
  &[data-toggle='true'] {
    transition-delay: 0ms;
    [data-id='${SWISHPANEL_CONTENT}'] {
      transform: translateX(0);
      transition-delay: ${TIMES.true - TIMES.false}ms;
      transition-duration: ${TIMES.true}ms;    
    }  
  }
`;

export const SwishPanelWrapperStyled = styled('div')`
  position: relative;
  box-sizing: border-box;
  background-color: white;
  transition: all ${TIMES.false}ms ${DEFAULT_TRANSITION_FUNC};
  transform: translateX(-110%);
  border-radius: ${(props) => props.theme.radius.default};
  box-shadow: ${(props) => props.theme.shadows.lg};
  margin: 0;
  width: 100vw;
  max-width: 100vw;
  height: min-content;
  min-height: 100%;
`;
